var _excluded = ["label", "error", "emptyLabel", "className", "options", "truncate"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { useState } from 'react';
import { apricot } from '../../profile';
import Label from './Label';
export default React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    error = _ref.error,
    _ref$emptyLabel = _ref.emptyLabel,
    emptyLabel = _ref$emptyLabel === void 0 ? 'Choose...' : _ref$emptyLabel,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    options = _ref.options,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? 50 : _ref$truncate,
    input = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocus = _useState2[1];
  var _ref2 = options.find(function (o) {
      return o.value == input.value;
    }) || {},
    _ref2$label = _ref2.label,
    selectedLabel = _ref2$label === void 0 ? '' : _ref2$label;
  var errId = error ? "errMessage-".concat(input.name) : null;
  var renderedLabel = selectedLabel.length > truncate ? apricot().utils.textTruncate(selectedLabel, truncate, 'last', '...') : selectedLabel;
  var onFocusHandler = function onFocusHandler(e) {
    setFocus(true);
    if (input.onFocus) input.onFocus(e);
  };
  var onBlurHandler = function onBlurHandler(e) {
    setFocus(false);
    if (input.onBlur) input.onBlur(e);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(className, " ").concat(error ? 'has-error' : '')
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    id: input.name,
    required: input.required
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-select-container"
  }, /*#__PURE__*/React.createElement("select", _extends({}, input, {
    id: input.name,
    className: "form-control replaced",
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    "aria-describedby": errId,
    ref: ref
  }), emptyLabel ? /*#__PURE__*/React.createElement("option", {
    value: ""
  }, emptyLabel) : null, options.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      value: c.value,
      key: c.value
    }, c.label);
  })), /*#__PURE__*/React.createElement("span", {
    className: "cb-select ".concat(focused ? 'focus' : '', " ").concat(input.disabled ? 'disabled' : ''),
    "aria-hidden": input.disabled
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
    className: "cb-select-arrow"
  }), renderedLabel || emptyLabel)))), error ? /*#__PURE__*/React.createElement("p", {
    tabIndex: "-1",
    id: errId,
    className: "cb-error-msg",
    role: "alert"
  }, error) : null);
});